import { decodeHTML } from 'entities';
import moment from 'moment';

const PopupMAGAF020 = ({ closePreview, dataPopup }) => {
    const formatDate = (date) => (date ? moment(date).locale('ko').format('YYYY.MM.DD') : '');
    const getGubun = (gubun) => {
        switch (gubun) {
            case '01':
                return '공지';
            case '02':
                return '뉴스';
            default:
                return '';
        }
    };
    return (
        <div id="content">
            <div className="container">
                <div id="popup" data-popup="issuance-individual-tickets">
                    <div className="overlay" />
                    <div className="popup-content">
                        <div className="popup-close" onClick={closePreview} />
                        <div className="popup-title">
                            <div className="vln-mgzn__top">
                                <div className="vln-mgzn__lf">
                                    <span className="vln-mgzn__gb blue">{getGubun(dataPopup?.gubun)}</span>
                                    <div className="vln-mgzn__tit">
                                        <h3>{dataPopup?.title}</h3>
                                    </div>
                                </div>
                                <div className="vln-mgzn__view">{formatDate(Date.now())}</div>
                            </div>
                        </div>
                        <div className="vln-mgzn__detail">
                            <div
                                className="vln-mgzn__cnt"
                                style={{ borderBottom: 'unset' }}
                                dangerouslySetInnerHTML={{
                                    __html: dataPopup?.contents
                                        ? decodeHTML(dataPopup?.contents)
                                        : '사용 가능한 콘텐츠가 없습니다.',
                                }}
                            ></div>
                        </div>
                        <div className="group-button center"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PopupMAGAF020;
